import { AxiosRequestConfig } from 'axios';
import incidentServices from '../services/incidentServices';
import { IncidentPostRequest, IncidentPutRequest } from '../@types/incidentTypes';
import { FileObject } from 'material-ui-dropzone';

export async function fetchPaginatedIncidents(config: AxiosRequestConfig) {
  const response = await incidentServices.getIncidents(config);
  return response;
}

export async function fetchIncidentById(id: string, config?: AxiosRequestConfig) {
  const response = await incidentServices.getIncidentById(id, config);
  return response;
}

export async function fetchIncidentsTileKey(config: AxiosRequestConfig) {
  config.params = {
    ...config.params,
    tileKey: true
  };
  const response = await incidentServices.getIncidents(config);
  return response;
}

export async function deleteIncidentById(id: string) {
  const response = await incidentServices.deleteIncidentById(id);
  return response;
}

export async function createIncident(incidentData: IncidentPostRequest) {
  const response = await incidentServices.createIncident(incidentData);
  return response;
}

export async function updateIncident(id: string, updatedIncidentData: IncidentPutRequest) {
  const response = await incidentServices.updateIncident(id, updatedIncidentData);
  return response;
}

export async function addImagesToIncident(recordId: string, files: FileObject[] | File[], filesDescriptions: string[]) {
  const imagens = mountImages(recordId, files, filesDescriptions);

  const response = await incidentServices.addImagesToIncident(imagens);
  return response;
}

export async function updateImagesOfIncident(recordId: string, files: FileObject[] | File[], filesDescriptions: string[], config: AxiosRequestConfig) {
  const imagens = mountImages(recordId, files, filesDescriptions);
  
  const response = await incidentServices.updateImagesOfIncident(imagens, config);
  return response;
}

export async function getImagesOfIncident(id: string) {
  const response = await incidentServices.getImagesOfIncident(id);
  return response;
}

export async function getSimplifiedZip(config: AxiosRequestConfig) {
  const response = await incidentServices.getSimplifiedZip(config);
  return response;
}

export async function getFullZip(config: AxiosRequestConfig) {
  const response = await incidentServices.getFullZip(config);
  return response;
}

export async function getInformationChartData(config: AxiosRequestConfig) {
  const response = await incidentServices.getInformationChartData(config);
  return response;
}










function mountImages(recordId: string, files: FileObject[] | File[], filesDescriptions: string[]) {
  const imagens = new FormData();
  
  files.forEach((file: FileObject | File, index: number) => {
    if (file instanceof File) {
      imagens.append(`files[${index}]`, file);
    } else {
      imagens.append(`files[${index}]`, file.file, file.file.name);
    }
  });
  imagens.append('recordID', recordId);
  imagens.append('descriptions', filesDescriptions.toString());

  return imagens;
}